import axiosService from '@/lib/axios'
import { TenantPublicResponse } from '@/types/tenant'

/** Anonymous — no credential needed, so it is callable from the browser and from RSC. */
export function getTenantPublic(tenantId: string) {
  return axiosService.get<TenantPublicResponse>(`/v1/tenant/${tenantId}/public`)
}
